var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-card',[_c('div',{staticClass:"link-card"},[_c('p',{staticClass:"mr-3",domProps:{"innerHTML":_vm._s(_vm.item.icon)}}),_c('div',[_c('h5',{staticClass:"text-base font-medium"},[_vm._v(" "+_vm._s(_vm.item.title)+" ")]),_c('p',{staticClass:"text-sm font-normal"},[_vm._v(_vm._s(_vm.item.sub))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }